
; var canvas, stage, exportRoot, anim_container, fnStartAnimation;
(function () {
    function initHomeAnimation() {
        var illustration = document.getElementById("home-illustration");
        if (illustration) {
            illustration.classList.add("is--visually-hidden");
            anim_container = document.getElementById("home-animation");
            anim_container.classList.remove('is--visually-hidden');
            canvas = document.getElementById("home-animation-canvas");
            var comp = AdobeAn.getComposition("506F0A69B96941109845E123CC01404A");
            var lib = comp.getLibrary();
            var loader = new createjs.LoadQueue(false);
            loader.addEventListener("fileload", function (evt) { handleFileLoad(evt, comp) });
            loader.addEventListener("complete", function (evt) { handleComplete(evt, comp) });
            var lib = comp.getLibrary();
            loader.loadManifest(lib.properties.manifest);
        }
    }

    function handleFileLoad(evt, comp) {
        var images = comp.getImages();
        if (evt && (evt.item.type == "image")) { images[evt.item.id] = evt.result; }
    }

    function handleComplete(evt, comp) {
        //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
        var lib = comp.getLibrary();
        var ss = comp.getSpriteSheet();
        var queue = evt.target;
        var ssMetadata = lib.ssMetadata;
        for (i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new createjs.SpriteSheet({ "images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames })
        }
        exportRoot = new lib.Novaware_home_animatie_v7();
        stage = new lib.Stage(canvas);
        //Registers the "tick" event listener.
        fnStartAnimation = function () {
            stage.addChild(exportRoot);
            createjs.Ticker.framerate = lib.properties.fps;
            createjs.Ticker.addEventListener("tick", stage);
            exportRoot.gotoAndStop(14);

            $(window).scroll(_.throttle(function () {
                var st = $(this).scrollTop();
                exportRoot.gotoAndStop(Math.round(st / 60) + 14);
            }, 4));
        }
        //Code to support hidpi screens and responsive scaling.
        AdobeAn.makeResponsive(false, 'both', false, 1, [canvas, anim_container]);
        AdobeAn.compositionLoaded(lib.properties.id);
        fnStartAnimation();
    }

    initHomeAnimation();
})();